import React from 'react';

import { Add } from '@mui/icons-material';
import { Button, Stack, useMediaQuery, useTheme } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import defaultPackageParameters from '../../constants/defaultPackageParameters';
import RefundForm from '../../models/RefundForm';
import { Package } from './components';

const PackagingStep: React.FC = () => {
    const { t } = useTranslation('refund', { keyPrefix: 'PACKAGING_STEP' });

    const theme = useTheme();

    const small = useMediaQuery(theme.breakpoints.down('md'));

    const form = useFormContext<RefundForm>();

    const { fields, remove, append } = useFieldArray({
        control: form.control,
        name: 'package_parameters',
    });

    const handleAdd = (): void => {
        append(defaultPackageParameters);
    };

    const handleRemove = (index: number): void => {
        remove(index);
    };

    return (
        <Stack paddingY={1} gap={2}>
            {fields?.map((_, index) => (
                <Package
                    key={index}
                    index={index}
                    onRemove={handleRemove.bind(this, index)}
                />
            ))}
            <Button
                sx={{ maxWidth: small ? 'auto' : 'fit-content' }}
                color="primary"
                startIcon={<Add />}
                onClick={handleAdd}
                variant="outlined"
            >
                {t('ADD_PACKAGE')}
            </Button>
        </Stack>
    );
};

export default PackagingStep;
